<div class="flex flex-column p-2 gap-20 justify-content-between h-full">
    <div class="w-full text-gray-300 font-normal padding-px-24 padding-py-4">
        <p>{{ description | translate }}</p>
    </div>
    <div class="flex gap-16">
        <p-button
            class="w-full"
            [outlined]="true"
            label="{{ 'default-cm-no' | translate: 'No' }}"
            styleClass="w-full h-3rem"
            (onClick)="onButtonClick(false)"
        ></p-button>
        <p-button
            class="w-full"
            label="{{ 'default-cm-yes' | translate: 'Yes' }}"
            styleClass="w-full h-3rem"
            (onClick)="onButtonClick(true)"
        ></p-button>
    </div>
</div>
